export default "__VITE_ASSET____sJw6SY__"